type ChipTone = 'default' | 'active';

interface MiniIntegrationChipProps {
  iconSrc: string;
  label: string;
  tone?: ChipTone;
  target?: string;
}

const TONE_TEXT: Record<ChipTone, string> = {
  default: 'text-text-quaternary',
  active: 'text-text-primary',
};

export function MiniIntegrationChip({ iconSrc, label, tone = 'default', target }: MiniIntegrationChipProps) {
  return (
    <div
      data-cursor-target={target}
      className="self-start flex items-center gap-1 px-1.5 py-0.5 rounded-pill border border-dashed border-border-default"
    >
      <img
        src={iconSrc}
        alt=""
        className={`w-[7px] h-[7px] shrink-0 ${tone === 'active' ? 'opacity-100' : 'opacity-60'}`}
      />
      <span className={`text-[7px] font-mono font-[var(--fw-medium)] ${TONE_TEXT[tone]}`}>{label}</span>
    </div>
  );
}
